/**
 * @generated SignedSource<<101ac7b273498d96f43f78a668bbfdff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotifyAboutJob_User$data = {
  readonly firstName: string | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "NotifyAboutJob_User";
};
export type NotifyAboutJob_User$key = {
  readonly " $data"?: NotifyAboutJob_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotifyAboutJob_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotifyAboutJob_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a9b802483603c1d18193af2cb325fe4a";

export default node;
